import { render } from "./PageLayoutSettings.vue?vue&type=template&id=e2712b20&scoped=true"
import script from "./PageLayoutSettings.vue?vue&type=script&lang=js"
export * from "./PageLayoutSettings.vue?vue&type=script&lang=js"

import "./PageLayoutSettings.vue?vue&type=style&index=0&id=e2712b20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2712b20"]])

export default __exports__